export default __webpack_public_path__ + "static/media/signal-check.5dfb75e1.png";